import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MixedText } from '../../utils/rtl';
import RestrictedAccessModal from './RestrictedAccessModal';

const RestrictedChatButton: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const handleChatToggle = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <button
        onClick={handleChatToggle}
        className="fixed bottom-4 md:bottom-6 right-4 md:right-6 z-[60] bg-gradient-to-r from-vibrant-orange to-vibrant-orange/90 hover:from-vibrant-orange/90 hover:to-vibrant-orange/80 text-white px-3 md:px-4 py-2.5 md:py-3 rounded-full shadow-lg shadow-vibrant-orange/30 transition-all duration-200 hover:scale-105 flex items-center gap-2 md:gap-3"
        title={t('sessions:flow.chat.openChat', 'Ask Question')}
      >
        <img
          src="/logo_v2.png"
          alt="StudyBel Astronaut"
          className="w-7 h-7 md:w-8 md:h-8 rounded-full bg-white/10 p-1"
        />
        <span className="font-medium text-xs md:text-sm whitespace-nowrap hidden sm:inline">
          <MixedText>{t('sessions:flow.chat.askQuestion', 'Ask Question')}</MixedText>
        </span>
      </button>

      <RestrictedAccessModal 
        isOpen={showModal} 
        onClose={handleClose} 
      />
    </>
  );
};

export default RestrictedChatButton;

